import avo from 'analytics/avo';
import isClient from 'commons/isClient';
import avoInspector from 'analytics/avoInspector';
import RudderstackAvoDestination from 'analytics/RudderstackAvoDestination';
import getEnvValue from 'commons/getEnvValue';
import isNewConsumerApp from 'commons/isNewConsumerApp';

const VERSION = isNewConsumerApp
  ? globalThis._env_?.NEXT_PUBLIC_BUILD_MODE || ''
  : getEnvValue('REACT_APP_VERSION') || '';

const initAvo = () => {
  if (isClient()) {
    avo.initAvo(
      {
        env:
          VERSION === 'development' ||
          VERSION === 'test' ||
          VERSION === 'staging'
            ? 'dev'
            : VERSION === 'production'
            ? 'prod'
            : VERSION,
        inspector: avoInspector,
        strict: false,
      },
      {
        userAgent: navigator.userAgent,
      },
      null,
      RudderstackAvoDestination
    );
  }
};

export default initAvo;
